import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

// The admin panel is served by the backend, not this display app. Anyone who
// lands on /admin here is sent to the configured backend/admin origin.
if (/^\/admin(\/|$)/.test(window.location.pathname)) {
  const apiBase = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');
  if (apiBase) {
    window.location.replace(`${apiBase}/admin/`);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
